import React, { useEffect, useState } from "react";
import Widget from "Components/Common/Widget/Widget";
import { IoToday } from "react-icons/io5";
import { MdNoAccounts } from "react-icons/md";
import { ImUserCheck } from "react-icons/im";
import DeleteReqList from "Components/AccountDeleteRequests/DeleteReqList";
import PercentageMeters from "Components/AccountDeleteRequests/PercentageMeters";
import { getAllAccDeleteReq, getAccDeleteStats } from "Common Usage/apiService";

const AccountDeleteReq = () => {
  const [accDelReq, setAccDelReq] = useState([]);
  const [userDataLoading, setUserDataLoading] = useState(true);
  const [stats, setStats] = useState({
    totalRequests: 0,
    todayRequests: 0,
    resolvedRequests: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedFilter, setSelectedFilter] = useState("All Request");

  const fetchUsers = async (page = 1, filterOption = selectedFilter) => {
    setUserDataLoading(true);
    try {
      setSelectedFilter(filterOption);

      const data = await getAllAccDeleteReq(page, 6, filterOption);

      setAccDelReq(data.data);
      setCurrentPage(data.currentPage);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error("Error fetching account delete requests:", error.message);
    } finally {
      setUserDataLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await getAccDeleteStats();
      setStats(res.stats);
    } catch (error) {
      console.error("Error fetching stats:", error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchStats();
  }, []);

  const resolvedPercentage =
    stats.totalRequests > 0
      ? (stats.resolvedRequests / stats.totalRequests) * 100
      : 0;
  const pendingPercentage =
    stats.totalRequests > 0
      ? ((stats.totalRequests - stats.resolvedRequests) / stats.totalRequests) *
        100
      : 0;

  return (
    <>
      {/* Stats Cards */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        <Widget
          icon={<MdNoAccounts className="h-6 w-6" />}
          title="Total Request Raised"
          subtitle={stats.totalRequests}
        />
        <Widget
          icon={<IoToday className="h-6 w-6" />}
          title="Request Raised Today"
          subtitle={stats.todayRequests}
        />
        <Widget
          icon={<ImUserCheck className="h-6 w-6" />}
          title="No. of Resolved Request"
          subtitle={stats.resolvedRequests}
        />
      </div>

      {/* Meters */}
      <PercentageMeters
        resolvedPercentage={resolvedPercentage}
        pendingPercentage={pendingPercentage}
      />

      {/* List */}
      <DeleteReqList
        accDelReq={accDelReq}
        userDataLoading={userDataLoading}
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={6}
        selectedFilter={selectedFilter}
        onPageChange={fetchUsers}
      />
    </>
  );
};

export default AccountDeleteReq;
